/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'

// polyfills for IE11 (better than including babel-polyfill --> huge)
import 'core-js/es6/promise'
import 'core-js/es6/symbol'
import 'core-js/fn/array/includes'
import 'core-js/fn/array/from'
import 'core-js/fn/string/starts-with'
import 'core-js/fn/string/includes'

import '../styles/styles.sass'
import routes from '../routes'
import store from '../store'


document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <Provider store={store}>
      <Router>{routes}</Router>
    </Provider>,
    document.getElementById('react'),
  )
})
